module.exports = __webpack_public_path__ + "static/media/online.29e4a3ee.svg";